(function () {
  // Product-page and Studio fields represent the same bag customization.
  document.addEventListener('input', function (event) {
    const input = event.target;
    if (!input.matches?.('[data-bcc-monogram][data-monogram-product]')) return;
    document.querySelectorAll('[data-bcc-monogram][data-monogram-product]').forEach(field => {
      if (field !== input && field.dataset.monogramProduct === input.dataset.monogramProduct) field.value = input.value;
    });
  });
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (Number.isNaN(number) || number == null) {
      return '0';
    }

    const fixed = (number / 100.0).toFixed(precision);
    const parts = fixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    const moneyFormat = format || '${{amount}}';

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = moneyFormat.match(placeholderRegex);
    const placeholder = match ? match[1] : 'amount';

    let value = '';
    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
    }

    return moneyFormat.replace(placeholderRegex, value);
  }

  function initProductRoot(root) {
    if (root.dataset.bccProductReady) return;
    root.dataset.bccProductReady = 'true';
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const colorOptionIndex = Number(root.dataset.colorOptionIndex || '-1');

    const variantsNode = root.querySelector('[data-bcc-variants]');
    if (!variantsNode) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    const hiddenVariantInput = root.querySelector('[data-bcc-variant-id-input]');
    const priceNode = root.querySelector('[data-bcc-price]');
    const compareNode = root.querySelector('[data-bcc-compare]');
    const saveNode = root.querySelector('[data-bcc-save]');
    const atcButton = root.querySelector('[data-bcc-atc]');
    let atcPriceNode = root.querySelector('[data-bcc-atc-price]');
    const buyNowButton = root.querySelector('[data-bcc-buy-now]');
    const titleColorNode = root.querySelector('[data-bcc-title-color]');
    const swatches = Array.from(root.querySelectorAll('[data-bcc-swatch]'));
    const mediaItems = Array.from(root.querySelectorAll('[data-media-id]'));

    const swatchColorValues = swatches.map((sw) => (sw.dataset.optionValue || '').trim().toLowerCase()).filter(Boolean);

    const initialId = hiddenVariantInput ? Number(hiddenVariantInput.value) : null;
    let currentVariant = variants.find((variant) => variant.id === initialId) || variants.find((variant) => variant.available) || variants[0];
    let selectedOptions = Array.isArray(currentVariant.options) ? currentVariant.options.slice() : [];

    function findVariantFromSelections(options) {
      let variant = variants.find((candidate) => {
        if (!Array.isArray(candidate.options) || candidate.options.length !== options.length) return false;
        return candidate.options.every((value, index) => value === options[index]);
      });

      if (!variant && colorOptionIndex > -1 && options[colorOptionIndex]) {
        variant = variants.find(
          (candidate) => Array.isArray(candidate.options) && candidate.options[colorOptionIndex] === options[colorOptionIndex] && candidate.available
        );
      }

      if (!variant && colorOptionIndex > -1 && options[colorOptionIndex]) {
        variant = variants.find(
          (candidate) => Array.isArray(candidate.options) && candidate.options[colorOptionIndex] === options[colorOptionIndex]
        );
      }

      return variant || null;
    }

    function isMediaMatch(media, variant, selectedColorLower) {
      if (colorOptionIndex < 0) {
        return true;
      }

      const variantIdsString = media.dataset.mediaVariantIds || '';
      const alt = (media.dataset.mediaAlt || '').toLowerCase();
      const mediaType = media.dataset.mediaType || '';

      if (mediaType === 'video' || mediaType === 'external_video') {
        return true;
      }

      const byVariantId = variantIdsString.includes(`,${variant.id},`);
      if (byVariantId) return true;

      if (!selectedColorLower) {
        return !variantIdsString || variantIdsString === ',';
      }

      const hasSelectedColorInAlt = alt.includes(selectedColorLower);
      if (hasSelectedColorInAlt) return true;

      const mentionsAnotherSwatchColor = swatchColorValues.some((value) => value && value !== selectedColorLower && alt.includes(value));
      if (mentionsAnotherSwatchColor) return false;

      const hasVariantAttachment = variantIdsString.length > 1;
      if (hasVariantAttachment) return false;

      return !alt || !swatchColorValues.some((value) => value && alt.includes(value));
    }

    function applyMediaLayout() {
      mediaItems.forEach((item) => {
        item.classList.remove('bcc-pdp__media-item--first-visible');
      });

      const firstVisible = mediaItems.find((item) => item.style.display !== 'none');
      if (firstVisible) {
        const mediaType = firstVisible.dataset.mediaType || '';
        if (mediaType !== 'video' && mediaType !== 'external_video') {
          firstVisible.classList.add('bcc-pdp__media-item--first-visible');
        }
      }
    }

    function filterMedia(variant) {
      const selectedColor = colorOptionIndex > -1 && variant.options ? variant.options[colorOptionIndex] : '';
      const selectedColorLower = (selectedColor || '').trim().toLowerCase();

      let visibleCount = 0;
      mediaItems.forEach((media) => {
        const shouldShow = isMediaMatch(media, variant, selectedColorLower);
        media.style.display = shouldShow ? '' : 'none';
        if (shouldShow) visibleCount += 1;
      });

      if (visibleCount === 0) {
        mediaItems.forEach((media) => {
          media.style.display = '';
        });
      }

      applyMediaLayout();
    }

    function updateSwatchStates(variant) {
      if (colorOptionIndex < 0 || !Array.isArray(variant.options)) return;
      const selectedColor = variant.options[colorOptionIndex];

      swatches.forEach((swatch) => {
        const swatchValue = swatch.dataset.optionValue || '';
        const isActive = swatchValue === selectedColor;
        swatch.classList.toggle('is-active', isActive);
        swatch.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    }

    function getBestCompareAt(variant, price) {
      const directCompare = Number(variant.compare_at_price || 0);
      if (directCompare > price) return directCompare;

      let bestMatch = 0;
      if (colorOptionIndex > -1 && Array.isArray(variant.options)) {
        const selectedColor = variant.options[colorOptionIndex];
        variants.forEach((candidate) => {
          if (!Array.isArray(candidate.options)) return;
          if (candidate.options[colorOptionIndex] !== selectedColor) return;
          const candidateCompare = Number(candidate.compare_at_price || 0);
          if (candidateCompare > price && candidateCompare > bestMatch) {
            bestMatch = candidateCompare;
          }
        });
      }

      if (bestMatch > price) return bestMatch;

      let globalMax = 0;
      variants.forEach((candidate) => {
        const candidateCompare = Number(candidate.compare_at_price || 0);
        if (candidateCompare > price && candidateCompare > globalMax) {
          globalMax = candidateCompare;
        }
      });

      if (globalMax > price) return globalMax;
      return price;
    }

    function updatePricing(variant) {
      const price = Number(variant.price || 0);
      const compareAt = getBestCompareAt(variant, price);
      const formattedPrice = formatMoney(price, moneyFormat);

      if (priceNode) {
        priceNode.textContent = formattedPrice;
      }

      if (atcPriceNode) {
        atcPriceNode.textContent = formattedPrice;
      }

      if (compareNode) {
        compareNode.textContent = formatMoney(compareAt, moneyFormat);
      }

      if (saveNode) {
        saveNode.textContent = `SAVE ${formatMoney(compareAt - price, moneyFormat)}`;
      }

      return formattedPrice;
    }

    function updateBuyState(variant, formattedPrice) {
      if (!hiddenVariantInput) return;
      hiddenVariantInput.value = String(variant.id);

      if (atcButton) {
        atcButton.disabled = !variant.available;
        if (!variant.available) {
          atcButton.textContent = 'SOLD OUT';
        } else {
          atcButton.innerHTML = `ADD TO BAG &middot; <span data-bcc-atc-price>${formattedPrice}</span>`;
          atcPriceNode = atcButton.querySelector('[data-bcc-atc-price]');
        }
      }
    }

    function updateTitleColor(variant) {
      if (!titleColorNode || colorOptionIndex < 0 || !Array.isArray(variant.options)) return;
      titleColorNode.textContent = variant.options[colorOptionIndex] || '';
    }

    function updateVariant(variant, updateUrl) {
      if (!variant) return;

      currentVariant = variant;
      selectedOptions = Array.isArray(variant.options) ? variant.options.slice() : selectedOptions;

      const formattedPrice = updatePricing(variant);
      updateBuyState(variant, formattedPrice);
      updateTitleColor(variant);
      updateSwatchStates(variant);
      filterMedia(variant);

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(
        new CustomEvent('bcc:variant-change', {
          bubbles: true,
          detail: {
            productId: root.dataset.productId,
            variantId: Number(variant.id || 0),
            price: Number(variant.price || 0),
            color:
              colorOptionIndex > -1 && Array.isArray(variant.options)
                ? String(variant.options[colorOptionIndex] || '')
                : '',
          },
        })
      );
    }

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', function () {
        const optionIndex = Number(swatch.dataset.optionIndex || colorOptionIndex);
        const optionValue = swatch.dataset.optionValue;
        if (Number.isNaN(optionIndex) || optionIndex < 0 || !optionValue) return;

        const nextSelection = selectedOptions.slice();
        nextSelection[optionIndex] = optionValue;

        const nextVariant = findVariantFromSelections(nextSelection);
        if (!nextVariant) return;

        updateVariant(nextVariant, true);
      });
    });

    const productForm = atcButton?.form;
    let addingToCart = false;
    if (productForm) {
      const cartError = document.createElement('p');
      cartError.setAttribute('role', 'alert');
      cartError.hidden = true;
      productForm.append(cartError);
      productForm.addEventListener('submit', async event => {
        event.preventDefault();
        if (addingToCart || !currentVariant?.available) return;
        addingToCart = true;
        atcButton.disabled = true;
        atcButton.textContent = 'ADDING…';
        cartError.hidden = true;
        const body = new FormData(productForm);
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
        body.set('sections', sections.join(','));
        body.set('sections_url', window.location.pathname);
        const route = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(`${route}cart/add.js`, {method:'POST', headers:{Accept:'application/json'}, body});
          const result = await response.json();
          if (!response.ok) throw Error(result.description || result.message || 'Unable to add this item. Please try again.');
          document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true, detail:{resource:result,sourceId:root.id || 'becco-product',data:{source:'product-form-component',itemCount:Number(body.get('quantity') || 1),sections:result.sections}}}));
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer?.open) drawer.open();
          else window.location.href = `${route}cart`;
        } catch (error) {
          cartError.textContent = error.message || 'Connection error. Please try again.';
          cartError.hidden = false;
        } finally {
          addingToCart = false;
          updateBuyState(currentVariant, formatMoney(currentVariant.price, moneyFormat));
        }
      });
    }

    if (buyNowButton) {
      buyNowButton.addEventListener('click', async function () {
        if (!currentVariant || !currentVariant.id || !currentVariant.available) return;

        const previousText = buyNowButton.textContent;
        buyNowButton.disabled = true;
        buyNowButton.textContent = 'PLEASE WAIT...';

        const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        try {
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: currentVariant.id,
              quantity: 1,
              properties: { Monogram: root.querySelector('[data-bcc-monogram]')?.value.trim() || '' },
            }),
          });
          if (!response.ok) throw new Error('Unable to add product');
          window.location.href = `${rootPath}checkout`;
        } catch (error) {
          buyNowButton.disabled = false;
          buyNowButton.textContent = previousText;
        }
      });
    }

    document.addEventListener('bcc:studio-variant-change', function (event) {
      if (String(event.detail.productId) !== root.dataset.productId) return;
      updateVariant(variants.find((v) => Number(v.id) === Number(event.detail.variantId)), true);
    });
    updateVariant(currentVariant, false);
  }

  function initializeProducts() { document.querySelectorAll('[data-bcc-product-root]').forEach(initProductRoot); }
  initializeProducts();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeProducts);
})();




